"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgArrowSmall = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 32, height: 32, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m31.979 16.838-1.998-.103a14.304 14.304 0 0 0 0-1.47l1.997-.103a16.27 16.27 0 0 1 0 1.676Zm-1.72-8.103-1.781.909c-.223-.436-.468-.86-.734-1.268l1.676-1.091c.304.467.584.95.84 1.45ZM24.715 2.58l-1.09 1.676a13.982 13.982 0 0 0-1.269-.734l.91-1.781c.498.255.982.535 1.45.839ZM16.838.022l-.103 1.997a14.259 14.259 0 0 0-1.47 0L15.162.022a16.264 16.264 0 0 1 1.676 0ZM8.735 1.74l.909 1.781c-.436.223-.86.468-1.268.734L7.285 2.58c.467-.304.95-.584 1.45-.84ZM2.58 7.285l1.676 1.09c-.266.41-.511.833-.734 1.269l-1.781-.91c.255-.498.535-.982.839-1.45ZM.022 15.162a16.264 16.264 0 0 0 0 1.676l1.997-.103a14.27 14.27 0 0 1 0-1.47l-1.997-.103Zm1.719 8.103 1.781-.909c.223.436.468.86.734 1.268L2.58 24.715a15.97 15.97 0 0 1-.84-1.45Zm5.544 6.155 1.09-1.676c.41.266.833.511 1.269.734l-.91 1.781a15.99 15.99 0 0 1-1.45-.839Zm7.877 2.558.103-1.997a14.304 14.304 0 0 0 1.47 0l.103 1.997a16.27 16.27 0 0 1-1.676 0Zm8.103-1.719-.909-1.781c.436-.223.86-.468 1.268-.734l1.091 1.676c-.467.304-.95.584-1.45.84Zm6.155-5.544-1.676-1.09c.266-.41.511-.833.734-1.269l1.781.91c-.255.498-.535.982-.839 1.45Z", fill: "#F7F9FF" }), (0, jsx_runtime_1.jsx)("path", { d: "M11.636 16.003h8.727M15.656 20.005l-4.02-4.002L15.656 12", stroke: "#F7F9FF", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }))); };
exports.default = SvgArrowSmall;
